import React, { useContext, useRef, useState } from "react";
import { VscLoading } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import axios from "../../util/axios";
import { Context } from "../../component/Context/ErrorContext";
import { Box, Modal } from "@mui/material";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../store/reducers/authSlice";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
  width: "100%",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  // p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  borderRadius: "10px",
};
const Login = () => {
  const navigate = useNavigate();
  const { setError } = useContext(Context);
  const dispatch = useDispatch();
  const otp1Ref = useRef(null);
  const otp2Ref = useRef(null);
  const otp3Ref = useRef(null);
  const otp4Ref = useRef(null);
  const otp5Ref = useRef(null);
  const otp6Ref = useRef(null);
  const [data, setData] = useState({
    email: "",
    password: "",
    error: {
      email: "",
      password: "",
    },
  });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [userId, setUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpScreenVisible, setOtpScreenVisible] = useState(false);
  const [otp, setOtp] = useState([]);

  const submitHandler = (e: any) => {
    e.preventDefault();
    if (data.email !== "" && data.password !== "") {
      setLoading(true);
      const formData = new FormData();
      formData.append("username", data.email);
      formData.append("password", data.password);
      axios({
        URL: "/omw/subAdmin/login",
        method: "POST",
        data: {
          email: data.email,
          password: data.password,
        },
      })
        .then((res: any) => {
          if (res.data) {
            if (res.data.status) {
              localStorage.setItem("user_token", res.data.data.access_token);
              dispatch(loginSuccess({ ...res.data.data, ...data }));
              navigate("/");
            } else {
              setError(res.data.message);
            }
          }
        })
        .catch((e) => {
          setError(e.response?.data?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (data.email === "") {
      setData((prev) => ({
        ...prev,
        error: { ...prev.error, email: "Please enter email" },
      }));
    }
    if (data.password === "") {
      setData((prev) => ({
        ...prev,
        error: { ...prev.error, password: "Please enter password" },
      }));
    }
  };

  const onChangeHandler = (e: React.FormEvent<HTMLInputElement>) => {
    const { id, value } = e.currentTarget;
    setData((prev) => ({ ...prev, [id]: value }));
  };

  const onOTPChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>,
    ref: any,
    otpStep: number
  ) => {
    const tempOTP: any = [...otp];
    tempOTP[otpStep] = e.currentTarget.value;
    setOtp(tempOTP);
    if (ref) {
      ref.current.focus();
    } else {
      if (otp6Ref.current) {
        (otp6Ref.current as any).blur();
      }
    }
  };

  const resendOTP = () => {
    setLoading(true);
    axios({
      URL: "/omw/send_otp/",
      method: "POST",
      data: {
        phone_number: phoneNumber,
      },
    })
      .then((res: any) => {
        if (res.data) {
          console.log(res.data);
        }
      })
      .catch((e) => setError(e.response?.data?.message))
      .finally(() => {
        setLoading(false);
      });
  };

  const otpConfirmSubmit = () => {
    setLoading(true);
    if (otp.length === 6) {
      axios({
        URL: "/omw/admin_verify_otp/",
        method: "POST",
        data: {
          phoneNumber: phoneNumber,
          otp: otp.join(""),
        },
      })
        .then((res: any) => {
          if (res.data) {
            if (res.data.status) {
              localStorage.setItem("user_token", res.data.data.access_token);
              axios({
                URL: `/omw/get_admin_details/${userId}`,
                method: "GET",
              })
                .then((resp: any) => {
                  const data = resp.data.data;
                  dispatch(loginSuccess({ ...res.data.data, ...data }));
                  navigate(
                    data?.user_type === "support" ? "/prizeFullfillment" : "/"
                  );
                })
                .catch((e) => setError(e.response?.data?.message))
                .finally(() => {
                  setLoading(false);
                });
            } else {
              setError(res.data.message);
            }
          }
        })
        .catch((e) => setError(e.response?.data?.message))
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <div
      className={
        "w-screen h-screen flex justify-center bg-gradient-to-t from-[#305FAA] to-[#17366D]"
      }
    >
      <div className={"flex flex-col w-full max-w-[1000px] pt-4 items-center"}>
        <img
          src={"/logo.png"}
          alt="logo"
          width={130}
          className={"self-start"}
        />
        <div
          className={
            "flex flex-col flex-1 w-full justify-start items-center pt-32 max-w-[500px] px-4"
          }
        >
          <p className={"text-4xl text-white"}>COMPANY SIGN IN</p>
          <form
            className={"w-full gap-5 mt-10 flex flex-col"}
            onSubmit={submitHandler}
          >
            <div className={"w-full flex flex-col items-start"}>
              <label
                htmlFor={"email"}
                className={"text-white text-sm font-bold"}
              >
                Email
              </label>
              <input
                id={"email"}
                className={"bg-white w-full rounded-md p-2 outline-none"}
                onChange={onChangeHandler}
                value={data.email}
                disabled={loading}
                type={"email"}
              />
              {data.error.email && (
                <p className={"text-red-600"}>{data.error.email}</p>
              )}
            </div>
            <div className={"w-full flex flex-col items-start"}>
              <label
                htmlFor={"password"}
                className={"text-white text-sm font-bold"}
              >
                Password
              </label>
              <input
                id={"password"}
                type={"password"}
                className={"bg-white w-full rounded-md p-2 outline-none"}
                onChange={onChangeHandler}
                value={data.password}
                disabled={loading}
              />
              {data.error.password && (
                <p className={"text-red-600"}>{data.error.password}</p>
              )}
            </div>
            <div className={"w-full flex items-center justify-between"}>
              <div className={"flex flex-col items-start"}>
                <div className={"gap-2 flex"}>
                  <input type={"checkbox"} id={"remember"} />
                  <label htmlFor="remember" className={"text-white text-sm"}>
                    Remember Me
                  </label>
                </div>
                <a
                  className={"cursor-pointer text-white text-sm"}
                  href={"/forgot-password"}
                >
                  Forgot Your Password?
                </a>
              </div>
              <button
                className={
                  "bg-[#43CB49] px-5 py-1 rounded text-white h-10 w-32 flex justify-center items-center"
                }
                type={"submit"}
                disabled={loading}
              >
                {loading ? (
                  <VscLoading className={"animate-spin text-2xl"} />
                ) : (
                  "Sign In"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      {otpScreenVisible ? (
        <Modal
          open={otpScreenVisible}
          onClose={() => {
            setOtpScreenVisible(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className={"flex justify-center items-center w-full h-full"}>
              <div
                className={
                  "bg-[#d6dce6] p-4 rounded-sm w-[96%] sm:w-full max-w-[500px] flex flex-col items-center"
                }
              >
                <p className={"text-[#151516] text-center"}>
                  Please enter the 6 digit code sent to your mobile device.
                </p>
                <div className={"flex justify-around mt-5 gap-6"}>
                  <input
                    className={
                      "w-10 pl-[15px] bg-white rounded-md h-12 text-xl flex justify-center items-center border-none outline-none"
                    }
                    maxLength={1}
                    value={otp[0] || ""}
                    ref={otp1Ref}
                    onChange={(e) =>
                      onOTPChangeHandler(
                        e,
                        e.currentTarget.value ? otp2Ref : otp1Ref,
                        0
                      )
                    }
                  />
                  <input
                    className={
                      "w-10 pl-[15px] bg-white rounded-md h-12 text-xl flex justify-center items-center border-none outline-none"
                    }
                    maxLength={1}
                    value={otp[1] || ""}
                    ref={otp2Ref}
                    onChange={(e) =>
                      onOTPChangeHandler(
                        e,
                        e.currentTarget.value ? otp3Ref : otp2Ref,
                        1
                      )
                    }
                  />
                  <input
                    className={
                      "w-10 pl-[15px] bg-white rounded-md h-12 text-xl flex justify-center items-center border-none outline-none"
                    }
                    maxLength={1}
                    value={otp[2] || ""}
                    ref={otp3Ref}
                    onChange={(e) =>
                      onOTPChangeHandler(
                        e,
                        e.currentTarget.value ? otp4Ref : otp3Ref,
                        2
                      )
                    }
                  />
                  <input
                    className={
                      "w-10 pl-[15px] bg-white rounded-md h-12 text-xl flex justify-center items-center border-none outline-none"
                    }
                    maxLength={1}
                    value={otp[3] || ""}
                    ref={otp4Ref}
                    onChange={(e) =>
                      onOTPChangeHandler(
                        e,
                        e.currentTarget.value ? otp5Ref : otp4Ref,
                        3
                      )
                    }
                  />
                  <input
                    className={
                      "w-10 pl-[15px] bg-white rounded-md h-12 text-xl flex justify-center items-center border-none outline-none"
                    }
                    maxLength={1}
                    value={otp[4] || ""}
                    ref={otp5Ref}
                    onChange={(e) =>
                      onOTPChangeHandler(
                        e,
                        e.currentTarget.value ? otp6Ref : otp5Ref,
                        4
                      )
                    }
                  />
                  <input
                    className={
                      "w-10 pl-[15px] bg-white rounded-md h-12 text-xl flex justify-center items-center border-none outline-none"
                    }
                    maxLength={1}
                    value={otp[5] || ""}
                    ref={otp6Ref}
                    onChange={(e) => onOTPChangeHandler(e, otp6Ref, 5)}
                  />
                  {/*<input*/}
                  {/*  className={*/}
                  {/*    "w-10 pl-[15px] bg-white rounded-md h-12 text-xl flex justify-center items-center border-none outline-none"*/}
                  {/*  }*/}
                  {/*  maxLength={1}*/}
                  {/*  value={otp[4] || ""}*/}
                  {/*  ref={otp5Ref}*/}
                  {/*  onChange={(e) => onOTPChangeHandler(e, null, 4)}*/}
                  {/*/>*/}
                </div>
                <button
                  className={
                    "w-[200px] bg-[#2f559b] text-white mt-5 py-2 rounded-md flex justify-center items-center"
                  }
                  onClick={otpConfirmSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <VscLoading className={"animate-spin text-2xl"} />
                  ) : (
                    "Confirm"
                  )}
                </button>
                <p className={"text-[#0c0c0c] mt-2"}>
                  Didn't get a code?{" "}
                  <span
                    className={"text-[#316bc0] cursor-pointer"}
                    onClick={resendOTP}
                  >
                    Resend
                  </span>
                </p>
                <p className={"text-[#0c0c0c]"}>
                  Or <span className={"text-[#316bc0]"}>click here</span> to use
                  another method.
                </p>
              </div>
            </div>
          </Box>
        </Modal>
      ) : null}
    </div>
  );
};

export default Login;
